module.exports = __webpack_public_path__ + "favicon-48.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/web/favicon-48.ico
// module id = 1063
// module chunks = 0